<ion-tabs>
    <ion-tab-bar
        slot="bottom"
        class="tab-bar"
        *ngIf="!router.url.includes('/cart') && !router.url.includes('/cart/checkout')"
    >
        <ion-tab-button tab="home">
            <tui-svg class="tab-bar-icon" [src]="'svg::home'"></tui-svg>
            <ion-label>{{ 'home' | transloco }}</ion-label>
        </ion-tab-button>

        <!--<ion-tab-button tab="stores" *ngIf="turnOnTheStoreChainLinkFeature$ | async">
            <tui-svg class="tab-bar-icon" src="svg::category"></tui-svg>
            <ion-label>{{ 'store' | transloco }}</ion-label>
        </ion-tab-button>-->

        <ion-tab-button tab="cart">
            <div class="relative">
                <tui-svg class="tab-bar-icon" [src]="'svg::cart'"></tui-svg>
                <div class="cart-badge">{{ totalNewItems$ | async }}</div>
            </div>
            <ion-label>{{ 'cart' | transloco }}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="account">
            <tui-svg class="tab-bar-icon" [src]="'svg::user'"></tui-svg>
            <ion-label>{{ 'other' | transloco }}</ion-label>
        </ion-tab-button>
    </ion-tab-bar>
</ion-tabs>
